"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service pro práci s typy dokumentu. Generated from cz.marbes.api.dokument.v1.TypDokumentService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:57:04Z                      #

// ##############################################################

var TypDokumentApi = function () {
  function TypDokumentApi() {
    (0, _classCallCheck3.default)(this, TypDokumentApi);
  }

  (0, _createClass3.default)(TypDokumentApi, null, [{
    key: "findTypyDokumentu",

    /**
     * Vrací všechny typy dokumentů seřazené dle {@link TypDokument#getNazev()}.
     *
     * @return typy dokumentů
     */
    value: function findTypyDokumentu() {
      var uri = serverContextPath + "/api/dokumenty/v1/typy/dokumentu/";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }

    /**
     * Aktualizace existujícího typu dokumentu.
     *
     * @param typDokumentKod kód typu dokumentu
     * @param typDokument 
     * @return aktualizovaný typ dokument
     */

  }, {
    key: "updateTypDokument",
    value: function updateTypDokument(typDokumentKod, typDokument) {
      var uri = serverContextPath + ("/api/dokumenty/v1/typy/dokumentu/" + typDokumentKod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, UpdateMethods.updateTypDokument_8E5AECv1(typDokument), headers));
    }

    /**
     * Dohledání typů dokumentu dle seznamu předaných kódů.
     *
     * @param kodTypDokuments seznam kódů typu dokumentu
     * @return seznam dohledaných typů dokumentu
     */

  }, {
    key: "getTypyDokumentu",
    value: function getTypyDokumentu(kodTypDokuments) {
      var uri = serverContextPath + "/api/dokumenty/v1/typy/dokumentu/batchRequest";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, kodTypDokuments, headers));
    }

    /**
     * Konfigurace typu dokumentu. Pokud neexistuje typ dokumentu s předaným kódem, založí ho. Pokud typ dokumentu existuje, vrací uložený záznam.
     *
     * @param kodTypDokument 
     * @param nazevDokument 
     * @return založeny typ dokumentu
     */

  }, {
    key: "createTypDokument",
    value: function createTypDokument(kodTypDokument, nazevDokument) {
      var uri = serverContextPath + "/api/dokumenty/v1/typy/dokumentu/create";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument, nazevDokument: nazevDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }

    /**
     * Vrací typ dokumentu s předanýcm kódem.
     *
     * @param kodTypDokument kód typu dokumentu
     * @return {@link TypDokument}
     */

  }, {
    key: "getTypDokumentByKod",
    value: function getTypDokumentByKod(kodTypDokument) {
      var uri = serverContextPath + "/api/dokumenty/v1/typy/dokumentu/";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Smaže typ dokumentu s daným kódem.
     *
     * @param typDokumentKod kód typu dokumentu
     */

  }, {
    key: "deleteTypDokument",
    value: function deleteTypDokument(typDokumentKod) {
      var uri = serverContextPath + ("/api/dokumenty/v1/typy/dokumentu/" + typDokumentKod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.delete(uri, params));
    }

    /**
     * Vrací kolekci šablon navázaných na typ dokumentu.
     *
     * @param kodTypDokument 
     * @return šablony navázané na typ dokumentu
     */

  }, {
    key: "getSablonyProTypDokumentu",
    value: function getSablonyProTypDokumentu(kodTypDokument) {
      var uri = serverContextPath + "/api/dokumenty/v1/typy/dokumentu/sablony";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return TypDokumentApi;
}();

exports.default = TypDokumentApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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